import { Box, LinearProgress, Typography, darken } from '@mui/material';

import { observer } from 'mobx-react-lite';

import { FC } from 'react';
import { Property } from '@codefluegel/wowis-rest-typescript-client';

import useReports from '../../hooks/useReports';
import DashbboardContainer from '../../components/container/DashbboardContainer';

interface Props {
  currentEstate: Property;
}

const DashReports: FC<Props> = observer(props => {
  const { currentEstate } = props;

  const { allReports } = useReports(currentEstate);

  // first 3 reports
  const transFormedReports = allReports?.slice(0, 3);

  return (
    <DashbboardContainer
      label="Schadensmeldungen"
      btnLabel="Zur Übersicht"
      linkTo="/schadensmeldungen"
    >
      <Box
        width={1}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box
          width={1}
          p={4}
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {transFormedReports?.map(report => (
            <Box
              key={report.schad_id}
              m={1}
              width={1}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Box p={0.1}>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: 'fontWeightBold' }}
                  color="secondary.main"
                >
                  Meldung
                </Typography>
              </Box>
              <Box p={1}>
                <Typography variant="body2" color="secondary.main">
                  {report?.schad_beschr}
                </Typography>
              </Box>
              <Box
                width={1}
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <Box
                  width={1}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyItems: 'center',
                    borderRadius: '25px',
                    outline: 'solid 1px',
                    outlineColor: darken('#F1F2F2', 0.2),
                    padding: '5px',
                  }}
                >
                  <Box width={1}>
                    <LinearProgress
                      variant="determinate"
                      sx={{
                        height: '12px',
                        borderRadius: '25px',
                        backgroundColor: 'secondary',
                        // bar color
                        '& .MuiLinearProgress-bar': {
                          backgroundColor:
                            report.schad_status === 'Abgelehnt'
                              ? 'primary.main'
                              : 'green',
                        },
                      }}
                      value={100}
                    />
                  </Box>
                </Box>

                <Box minWidth={100}>
                  <Typography
                    variant="subtitle2"
                    color="primary"
                    textAlign="right"
                  >
                    {report?.schad_status?.toUpperCase()}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </DashbboardContainer>
  );
});

export default DashReports;
